// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  /* font sizes in vuetify are in rem units. To get the correct font size, the html tag has to have a font size of 
     * 16px */
  font-size: 16px;
}

.vuetify-styles {
  font-family: "Roboto", sans-serif;
  line-height: 1.5;
  font-size: 1rem;
  overflow-x: hidden;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  --v-theme-overlay-multiplier: 1;
  --v-scrollbar-offset: 0px;
}

/* iOS Safari hack to allow click events on body */
@supports (-webkit-touch-callout: none) {
  body {
    /* TODO: prevent scopify of prefixing this */
    cursor: pointer;
  }
}

/* fix for override from jp-ThemedContainer button */
button.v-btn--rounded {
  border-radius: 28px;
}
`, "",{"version":3,"sources":["webpack://./lib/ipyvuetify-styles.css"],"names":[],"mappings":"AAAA;EACE;aACW;EACX,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,kCAAkC;EAClC,mCAAmC;EACnC,kCAAkC;EAClC,6CAA6C;EAC7C,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA,kDAAkD;AAClD;EACE;IACE,4CAA4C;IAC5C,eAAe;EACjB;AACF;;AAEA,oDAAoD;AACpD;EACE,mBAAmB;AACrB","sourcesContent":["html {\n  /* font sizes in vuetify are in rem units. To get the correct font size, the html tag has to have a font size of \n     * 16px */\n  font-size: 16px;\n}\n\n.vuetify-styles {\n  font-family: \"Roboto\", sans-serif;\n  line-height: 1.5;\n  font-size: 1rem;\n  overflow-x: hidden;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  --v-theme-overlay-multiplier: 1;\n  --v-scrollbar-offset: 0px;\n}\n\n/* iOS Safari hack to allow click events on body */\n@supports (-webkit-touch-callout: none) {\n  body {\n    /* TODO: prevent scopify of prefixing this */\n    cursor: pointer;\n  }\n}\n\n/* fix for override from jp-ThemedContainer button */\nbutton.v-btn--rounded {\n  border-radius: 28px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
